import React from 'react';
import DOMPurify from 'dompurify';
import {Typography} from '@mui/material';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // Set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noreferrer noopener');
  }
});

interface DangerousHTMLProps {
  text: string | undefined;
  style?: React.CSSProperties;
}

export const DangerousHTML: React.FC<DangerousHTMLProps> = ({text, style}) => {
  return (
    <Typography
      variant="body1"
      component="div"
      sx={(theme) => ({
        a: {color: theme.palette.info.main, textDecoration: 'underline'},
      })}
      style={style}
      dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text ?? '')}}
    />
  );
};
